// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3w-C9","filesListContainer":"PosDisputesFiles_filesListContainer__hIaC9","filesButton":"PosDisputesFiles_filesButton__2g3Kt"};